import * as React from 'react';
import { ReactComponent as Logo } from 'src/assets/images/shell-logo.svg';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { HOME_PAGE_ROUTE } from '../../pages/home/page';
import { White2 } from '../../styles/colours';
import { CustomerSearchDropdown } from '../customer-search';

const StyledHeader = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem 2rem;
  background: ${White2};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
  z-index: 2;

  @media print {
    display: none;
  }
`;

const StyledLogoLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 2rem;
`;

export const Header = () => {
  return (
    <StyledHeader>
      <StyledLogoLink to={HOME_PAGE_ROUTE}>
        <Logo />
      </StyledLogoLink>
      <CustomerSearchDropdown />
    </StyledHeader>
  );
};
